module.exports = __webpack_public_path__ + "img/seller-b1.60e4632f.png";